var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container flex content-center justify-center flex-wrap"},[_c('section',{staticClass:"text-center"},[(_vm.code)?_c('h1',{staticClass:"title"},[_vm._v("Error "+_vm._s(_vm.code))]):_vm._e(),(_vm.message)?_c('h3',{staticClass:"subtitle",domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }